module.exports = __webpack_public_path__ + "columns.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/columns.svg?color1=%23333333&color2=
// module id = 2191
// module chunks = 67